import React, { useState, Fragment } from 'react';
import { Radio, Tabs, Input, Modal } from 'antd';
import { Form } from '@ant-design/compatible';
import BasicInfoStepsByShell from './BasicInfoStepsByShell';
import AdvanceInfoStepsByShell from './AdvanceInfoStepsByShell';
import ScanRunningInstances from './ScanRunningInstances';

const { TextArea } = Input;
const { TabPane } = Tabs;
const customStyles = {
  stepsHeadings: {
    color: 'black',
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem',
  },
  cardMain: {
    backgroundColor: '#FAFAFA',
    padding: ' 1rem 2rem',
    marginBottom: '25px',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  index: {
    color: 'lightgrey',
    margin: 0,
    border: '1px solid lightgrey',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '25px',
    width: '25px',
    borderRadius: '50%',
  },
};

const InfoSteps = ({ protectionLevel, props }) => {
  if (protectionLevel === 'basic') {
    return <BasicInfoStepsByShell props={props} />;
  } else if (protectionLevel === 'advanced') {
    return <AdvanceInfoStepsByShell props={props} />;
  }
};
function GCPCredentialForm(props) {
  const { protectionLevel, accountName } = props.sentRequireData;

  return (
    <Fragment>
      <h5 style={customStyles.stepsHeadings}>
        <span>Create Service Account</span>
      </h5>

      <InfoSteps protectionLevel={protectionLevel} props={props} />
      {protectionLevel === 'advanced' && <ScanRunningInstances />}
    </Fragment>
  );
}
const WrappedApp = Form.create()(GCPCredentialForm);

export default WrappedApp;
